<div class="section-page">
    <div class="section-header-bar" [class.section-header-bar--scrolled]="isScrolled">
        <div class="section-header">
            <div class="section-header__title">
                <mat-icon class="section-header__icon">assignment</mat-icon>
                <div>
                    <div class="section-header__heading">Underwriting</div>
                    <div class="section-header__subtitle">Loan interview and underwriting</div>
                </div>
            </div>
        </div>
    </div>

    <div class="my-custom-tabs-container">
        <mat-tab-group dynamicHeight>
                <mat-tab label="Loan Interview" > 
                    <app-loan-interview 
                        [(application)]="application"
                        [(currentUser)]="currentUser"
                        (applicationChange)="onApplicationChanged($event)">
                    </app-loan-interview>
                </mat-tab>
            <mat-tab label="Underwriting">
                <ng-template matTabContent>
                    <app-underwriting            
                        [(application)]="application"
                        [(currentUser)]="currentUser"
                        (applicationChange)="onApplicationChanged($event)">
                    </app-underwriting>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>
